import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typographyMixin } from '@equinor/eds-utils';
import { helperText } from './HelperText.token.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["text", "icon", "color"];
var Container = styled.div.withConfig({
  displayName: "HelperText__Container",
  componentId: "sc-189ug61-0"
})(function (_ref) {
  var color = _ref.color;
  return css({
    display: 'grid',
    gap: '8px',
    gridAutoFlow: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    color: color
  });
});
var Text = styled.p.withConfig({
  displayName: "HelperText__Text",
  componentId: "sc-189ug61-1"
})(["margin:0;", ";"], typographyMixin(helperText.typography));
var TextfieldHelperText = /*#__PURE__*/forwardRef(function TextfieldHelperText(_ref2, ref) {
  var text = _ref2.text,
    icon = _ref2.icon,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? helperText.typography.color : _ref2$color,
    rest = _objectWithoutProperties(_ref2, _excluded);
  if (!text) {
    return null;
  }
  return /*#__PURE__*/jsxs(Container, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, rest), {}, {
    color: color,
    ref: ref
  })), {}, {
    children: [icon, /*#__PURE__*/jsx(Text, {
      children: text
    })]
  }));
});

export { TextfieldHelperText as HelperText };
